import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../../components/Modal/ModalContext';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useChangePassword = () => {
    const modalContext = useContext(ModalContext);
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onChangePasswordError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while changing the password.',
        );
    };

    const onChangePasswordSuccess = (callbackFn: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Password changed successfully.',);
        modalContext?.setShowSuccessComponent(true);
        callbackFn();
    };

    const changePassword = (data: any, callbackFn?: () => void) => {
        const url: HttpConfig = {
            url: 'api/v1/auth/update-password',
            method: 'patch',
            data: data
        };

        request(url, onChangePasswordSuccess(callbackFn ?? (() => {})), setLoading, onChangePasswordError);
    };

    return { changePassword, loading };
};

export default useChangePassword;
